import { render, staticRenderFns } from "./expert-team.vue?vue&type=template&id=11634c06&scoped=true"
import script from "./expert-team.vue?vue&type=script&lang=js"
export * from "./expert-team.vue?vue&type=script&lang=js"
import style0 from "./expert-team.vue?vue&type=style&index=0&id=11634c06&prod&scoped=true&lang=scss"
import style1 from "./expert-team.vue?vue&type=style&index=1&id=11634c06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11634c06",
  null
  
)

export default component.exports